export default __webpack_public_path__ + "static/media/CarteMot.6f3a0201.png";